var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome2Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0909 9.48626C22.6969 10.6236 23 12.1822 23 14.1621C23 16.0998 22.5606 17.9533 21.6818 19.7225C20.803 21.4496 19.6666 22.924 18.2727 24.1456C15.4242 26.7152 12.197 28 8.59092 28C5.10605 28 2.63636 26.7573 1.18181 24.2719C0.393939 22.8818 0 21.239 0 19.3434C0 15.5943 1.37879 12.2665 4.13636 9.35989C6.89393 6.4533 10.1818 5 14 5C17.8485 5 20.5454 6.49542 22.0909 9.48626Z",
    fill: "#FFC8B6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2049 0.278894C14.6698 -0.0929647 15.3302 -0.0929647 15.7951 0.278894L28.5223 10.4607C28.8242 10.7022 29 11.0679 29 11.4545V26.7273C29 27.4302 28.4302 28 27.7273 28H20.0909C19.388 28 18.8182 27.4302 18.8182 26.7273V16.5455H11.1818V26.7273C11.1818 27.4302 10.612 28 9.90909 28H2.27273C1.56982 28 1 27.4302 1 26.7273V11.4545C1 11.0679 1.17575 10.7022 1.47766 10.4607L14.2049 0.278894ZM3.54545 12.0662V25.4545H8.63636V15.2727C8.63636 14.5698 9.20618 14 9.90909 14H20.0909C20.7938 14 21.3636 14.5698 21.3636 15.2727V25.4545H26.4545V12.0662L15 2.90261L3.54545 12.0662Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome2Icon);
export default __webpack_public_path__ + "static/media/Home2Icon.45653d777663dbb3faba522c95f2a257.svg";
export { ForwardRef as ReactComponent };